/** @jsxImportSource react */
import { recordEntityCta } from '@common/helpers/localStorage';
import { objectToURLQueryParams } from '@common/helpers/url';
import { getModalFromEntry } from '@common/helpers/wizard';
import clsxm from '@common/lib/clsxm';
import withPostConversionModal from '@react/cta/hoc/withPostConversionModal';
import TypeformWizard from '@react/cta/TypeformWizard/Wizard';
import redirectTo from '@react/services/redirectTo/redirectTo';
import Modal, { ModalBody } from '@react/shared/components/NewModal';
import { Button } from '@react/system';
import {
  ASSESSMENT_WIZARD_COMPLETED,
  ASSESSMENT_WIZARD_COMPLETED_COMMUNITIES,
} from '@sly/core/constants/assessment';
import { FAMILY_DASHBOARD_HOME_PATH } from '@sly/core/constants/dashboardAppPaths';
import { object } from 'proptypes';
import React, { useState } from 'react';
import { typeformFormId } from 'sly/config';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const TypeformCta = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    ctaProps,
    mode,
    community,
    className,
    hidePricing,
    pricingRef,
    wizardType,
    ...rest
  } = props;

  const { text: buttonText, prop: formId, variant, palette } = ctaProps;
  const typeformWizardProps = {
    ...rest,
    formId: formId || typeformFormId,
    buttonText,
    wizardType: wizardType || 'POPUP_BUTTON',
    palette,
    variant,
    className: clsxm(className, 'w-full'),
  };

  const onTypeformSubmissionHandler = () => {
    if (community) {
      recordEntityCta(ASSESSMENT_WIZARD_COMPLETED_COMMUNITIES, community.id);
      localStorage.setItem(
        ASSESSMENT_WIZARD_COMPLETED,
        ASSESSMENT_WIZARD_COMPLETED
      );

      if (hidePricing && community) {
        setIsModalOpen(true);
        return;
      }

      if (mode) {
        const qp = {};
        const modal = getModalFromEntry(mode.entry);
        if (modal) {
          qp.modal = modal;
        }
        qp.communityName = community.name;
        const redirectPath = `${FAMILY_DASHBOARD_HOME_PATH}?${objectToURLQueryParams(
          qp
        )}`;
        redirectTo(redirectPath);
      }
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {isModalOpen && (
        <Modal className='p-xl' onClose={closeModal} isOpen={isModalOpen}>
          <ModalBody className='font-t-s-azo mb-xl'>
            Thanks for requesting pricing for this community. Based on our
            recent assessments here is your pricing per room types
          </ModalBody>
          <Button
            onClick={() => {
              closeModal();
              if (pricingRef) {
                pricingRef?.current?.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            data-tp-id='gen-Button-32e29f3c-2cdc-4b97-acea-5edbdcc8e02f'
          >
            Ok
          </Button>
        </Modal>
      )}
      <TypeformWizard
        onTypeformSubmissionHandler={
          community ? onTypeformSubmissionHandler : noop
        }
        {...typeformWizardProps}
      />
    </>
  );
};

TypeformCta.propTypes = {
  ctaProps: object,
  community: object,
  mode: object,
};

export default withPostConversionModal(TypeformCta);
